import RadioGroup from "../inputs/RadioGroup";
import { RadioGroupFieldsetProps } from "./FieldsetProps";
import { RadioButtonField } from "../inputs/InputProps";

import "./Fieldset.scss";

const SurveyMonumentFee: React.FC<RadioGroupFieldsetProps> = ({ currentSelection, setCurrentSelection }) => {
    const radioFields: RadioButtonField[] = [
        {
            id: "0",
            label: "Yes, the document qualifies for a survey monument fee.",
        },
        {
            id: "1",
            label: "No, the document does not qualify for a survey monument fee.",
        },
    ];

    return (
        <fieldset className="fee-calc-fieldset">
            <legend>
                <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                <span className="sr-only">Required</span>
                A Survey Monument Fee is applicable when someone is coming off of title
                <br />
                <strong className="and-separator">AND</strong>
                <br />
                When the legal description on the Deed does not read as a complete Lot and Tract (
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=27585.&lawCode=GOV"
                >
                    <abbr title="Government Code">GC</abbr>27585
                </a>
                ). An example of an incomplete legal description would be when it reads as a portion of a lot such as NW
                ½ of... or it may include a section, township range... or xxx feet of the SW...
            </legend>
            <RadioGroup
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                fieldsetId="SurveyMonumentFee"
                fields={radioFields}
            />
        </fieldset>
    );
};

export default SurveyMonumentFee;
